<ng-template let-data #articleTplImage>
    <div clasS="is-relative container-image-notification">
        <iw-shop-article-notification *ngIf="isNotification"
                                      [notifications]="data.article.notifications"></iw-shop-article-notification>
        <div class="container-image is-flex is-align-items-flex-end">
            <a

                    [routerLink]="['/sortiment', 'details', data.article.articleNumber, articleTemplateService.getParamForUrl(data.article.name)]"
                    (click)="articleTemplateService.goToArticle(data.article)">
                <img *ngIf="data.article.images && data.article.images[0]" alt="{{data.article.name}}"
                     src="{{resourceUrl + data.article.images[0].thumbnails.small}}">
                <fa-icon *ngIf="!data.article.images || data.article.images.length == 0" [icon]="faImages" role="img" aria-label="Für das Produkt ist kein Bild vorhanden"

                         class="is-size-1 img m-auto"></fa-icon>

            </a>
        </div>
    </div>

</ng-template>
<ng-template let-data #articleTplSub>
    <div class="container-last-column is-flex has-text-right">
        <div class="is-size-7 is-flex-grow-1">Art.-Nr. {{ data.article.articleNumber }}</div>
        <div class="availability  is-flex-grow-1"
             [style.color]="this.articleService.getAvailabilityColor(data.article.inventory || 0, data.article.availability)">
            &nbsp; {{ this.articleService.getAvailability(data.article.inventory || 0, data.article.availability) }}
        </div>
        <div class="container-cart">
            <iw-shop-article-cart-button [article]="data.article"
                                         [showOverlayPanel]="true"></iw-shop-article-cart-button>
        </div>
    </div>
</ng-template>
<ng-template let-data #articleTpl>
    <hr class="my-1 mx-1"/>
    <a name="{{data.article.articleNumber}}"></a>
    <div class="columns is-align-items-center is-gapless mb-0  is-mobile is-multiline pb-3">
        <div class="column is-6 is-hidden-tablet">
            <ng-container
                    *ngTemplateOutlet="articleTplImage; context: {$implicit: {article: data.article}}"></ng-container>
        </div>
        <div class="column is-6-mobile is-12-tablet">
            <div class="columns is-align-items-flex-end is-gapless mb-0  is-mobile is-multiline">
                <div class="column is-6-touch is-hidden-mobile is-align-self-stretch">
                    <ng-container
                            *ngTemplateOutlet="articleTplImage; context: {$implicit: {article: data.article}}"></ng-container>
                </div>
                <div class="column is-12-mobile is-6-tablet is-3-desktop has-text-right">
                    <div class="my-1">
                <span *ngIf="data.article.unit != 0">
                    <span class="quantity">{{ data.article.quantity }}</span>
                    <span class="quantity-addition" *ngIf="(data.article.quantityAddition?.length ?? 0) > 0">&nbsp;{{data.article.quantityAddition}}</span>
                    <span class="quantity-x-unit">&nbsp;x&nbsp;</span>
                    <span class="unit">{{ NumberFormat(data.article.unit) }}</span>
                </span>
                        <span class="unit-of-measurement" *ngIf="(data.article.unitOfMeasurement?.length ?? 0) > 0">{{data.article.unitOfMeasurement}} </span>
                        <span class="unit-addition" *ngIf="(data.article.unitAddition?.length ?? 0) > 0">{{data.article.unitAddition}} </span>
                        <span class="package-type" *ngIf="data.article.packageType"> {{ data.article.packageType }} </span>
                        <span class="unit-type" *ngIf="data.article.unitType"> {{ data.article.unitType }} </span>
                    </div>
                    <div class="is-size-7">
                        <div>
                    <span *ngIf="data.article.bestPrice?.netDeposit!==0">
                        + Pfand {{ articleService.getPrice(data.article.bestPrice?.netDeposit || 0, configService.getDepositTaxRate(), (customer$ | async)?.priceMode || 'gross') }}
                    </span>
                            <span *ngIf="data.article.bestPrice && data.article.bestPrice.netFee && data.article.bestPrice.netFee > 0 && (customer$ | async)?.priceMode == 'net'">
                        und Gebühren
                    </span>
                            <div class="is-flex">
                                <div class="is-flex-grow-1 has-text-right pr-4">
                                    <iw-shop-article-favorite-button
                                            [articleNumber]="data.article.articleNumber"></iw-shop-article-favorite-button>
                                </div>
                                <a [routerLink]="['/sortiment', 'details', data.article.articleNumber, articleTemplateService.getParamForUrl(data.article.name)]"
                                   (click)="articleTemplateService.goToArticle(data.article)"
                                   class="link-product-details-lmiv mt-2 is-block is-size-7">Produktdetails  <span class="lmiv">/ LMIV</span></a>
                            </div>


                            <!--        <span *ngIf="data.article.allergenIngredients" class="legal">
                                                        <b>Allergene: </b>
                                                        <b *ngFor="let item of data.article.allergenIngredients">{{item}}</b>
                                                      </span>
                                                        <span *ngIf="data.article.additives" class="legal" >
                                                        Zusatzstoffe: <span *ngFor="let item of data.article.additives">{{item}}</span>
                                                      </span>
                                                        <span *ngIf="data.article.alcoholicStrength" class="legal" >
                                                        Alkoholgehalt: {{data.article.alcoholicStrength}}%
                                                      </span>
                                                        <span *ngIf="data.article.caffeine" class="legal" >
                                                        Koffeingehalt: {{data.article.caffeine}}
                                                      </span>-->
                        </div>
                    </div>
                </div>
                <div class="column is-12-mobile is-6-tablet is-3-desktop">
                    <div class="mx-4-tablet">
                        <iw-shop-article-price [article]="data.article"></iw-shop-article-price>
                    </div>

                </div>
                <div class=" is-hidden-mobile column is-12-mobile is-6-tablet is-3-desktop is-align-self-stretch">
                    <ng-container
                            *ngTemplateOutlet="articleTplSub; context: {$implicit: {article: data.article}}"></ng-container>
                </div>
            </div>

        </div>
        <div class="column is-12 is-hidden-tablet">
            <ng-container
                    *ngTemplateOutlet="articleTplSub; context: {$implicit: {article: data.article}}"></ng-container>
        </div>
    </div>
</ng-template>


<div *ngIf="article" class="container-article-list is-block px-4 has-background-white">
    <div class="is-flex">
        <a
                [routerLink]="['/sortiment', 'details', article.articleNumber, articleTemplateService.getParamForUrl(article.name)]"
                (click)="articleTemplateService.goToArticle(article)"
                class="name mt-2 is-block has-text-weight-semibold is-size-5 is-size-6-mobile ">
            <span *ngIf="getRelatedArticles(article.relatedArticleGroup).length > 0">{{ article.relatedArticleGroup }} </span>
            <div *ngIf="getRelatedArticles(article.relatedArticleGroup).length == 0" class="is-flex">

                <div>
                    <span>{{ article.name }} </span>
                </div>
            </div>

        </a>
    </div>
    <ng-container *ngIf="articlesWithCommonRelatedGroup.length == 0">
        <ng-container *ngTemplateOutlet="articleTpl; context: articleContext"></ng-container>
    </ng-container>

    <ng-container *ngIf="articlesWithCommonRelatedGroup.length > 0">
        <ng-container *ngFor="let item of getRelatedArticles(article.relatedArticleGroup)">
            <ng-container *ngTemplateOutlet="articleTpl; context: {$implicit: {article: item}}"></ng-container>
        </ng-container>
    </ng-container>
    @if (userService.hasLoggedInUserAccess({ type: 'prices', customerId: (customer$ | async)?.id ?? '' })) {
    <span *ngIf="(customer$ | async)?.priceMode == 'net'">Exkl.</span>
    <span *ngIf="(customer$ | async)?.priceMode != 'net'">Inkl.</span>
    gesetzlicher MwSt.<span class="link-delivery-costs">, zzgl. <a routerLink="/lieferkosten">Lieferkosten</a></span>
    }
</div>
